import { gfs } from '@/utils/functional'
import { keys } from 'ramda'

const UPDATE_LOGIN_DIALOG = 'UPDATE_LOGIN_DIALOG'

const state = {
  loginDialog: null
}
export default {
  namespaced: true,
  state,
  mutations: {
    [UPDATE_LOGIN_DIALOG](state, data) {
      state.loginDialog = data
    }
  },
  actions: {
    updateLoginDialog({ commit }, params) {
      commit(UPDATE_LOGIN_DIALOG, params)
    }
  },
  getters: {
    ...gfs(keys(state))
  }
}
